const ALL = {
  assets: 'assets',
  collections: 'collections',
  export_locations: 'export_locations',
  saved_searches: 'saved_searches',
  saved_search_groups: 'saved_search_groups',
  formats: 'formats',
  files: 'files',
  transcoders: 'transcoders',
  storages: 'storages',
  discoveries: 'discoveries',
  segments: 'segments',
  search: 'search',
  subclips: 'subclips',
  groups: 'groups',
  keyframes: 'keyframes',
  webhooks: 'webhooks',
  applications: 'applications',
  custom_actions: 'custom_actions',
  relation_types: 'relation_types',
  jobs: 'jobs',
  widgets: 'widgets',
  users: 'users',
  shares: 'shares',
  share_users: 'share_users',
  metadata_categories: 'metadata_categories',
  metadata_views: 'metadata_views',
  search_views: 'search_views',
  metadata_fields: 'metadata_fields',
  acl_templates: 'acl_templates',
  identity_providers: 'identity_providers',
  ip_addresses: 'ip_addresses',
  log_stream_recipients: 'log_stream_recipients',
  persons: 'persons',
  automations: 'automations',
  asset_persons: 'asset_persons',
  playlists: 'playlists',
  portals: 'portals',
} as const;

export type ObjectType = keyof typeof ALL;

const objectTypeSet: ReadonlySet<string> = new Set(Object.keys(ALL));

// An object_type arrives off the API as an optional plain string, so the
// check starts from whatever the caller has.
export const isObjectType = (value: unknown): value is ObjectType =>
  typeof value === 'string' && objectTypeSet.has(value);

export type SearchObjectType =
  | (typeof ALL)['assets']
  | (typeof ALL)['collections'];

/** The two object types the search endpoint indexes. */
export const SEARCH_OBJECT_TYPES: readonly SearchObjectType[] = [
  ALL.assets,
  ALL.collections,
];

const searchObjectTypeSet: ReadonlySet<string> = new Set(SEARCH_OBJECT_TYPES);

export const isSearchObjectType = (value: string): value is SearchObjectType =>
  searchObjectTypeSet.has(value);

export const OBJECT_TYPE_ASSETS = 'assets' as const;
export const OBJECT_TYPE_COLLECTIONS = 'collections' as const;
export const OBJECT_TYPE_EXPORT_LOCATIONS = 'export_locations' as const;
export const OBJECT_TYPE_SAVED_SEARCHES = 'saved_searches' as const;
export const OBJECT_TYPE_SAVED_SEARCH_GROUPS = 'saved_search_groups' as const;
export const OBJECT_TYPE_FORMATS = 'formats' as const;
export const OBJECT_TYPE_FILES = 'files' as const;
export const OBJECT_TYPE_TRANSCODERS = 'transcoders' as const;
export const OBJECT_TYPE_STORAGES = 'storages' as const;
export const OBJECT_TYPE_DISCOVERIES = 'discoveries' as const;
export const OBJECT_TYPE_SEGMENTS = 'segments' as const;
export const OBJECT_TYPE_GROUPS = 'groups' as const;
export const OBJECT_TYPE_KEYFRAMES = 'keyframes' as const;
export const OBJECT_TYPE_WEBHOOKS = 'webhooks' as const;
export const OBJECT_TYPE_APPLICATIONS = 'applications' as const;
export const OBJECT_TYPE_CUSTOM_ACTIONS = 'custom_actions' as const;
export const OBJECT_TYPE_RELATION_TYPES = 'relation_types' as const;
export const OBJECT_TYPE_JOBS = 'jobs' as const;
export const OBJECT_TYPE_WIDGETS = 'widgets' as const;
export const OBJECT_TYPE_USERS = 'users' as const;
export const OBJECT_TYPE_SHARES = 'shares' as const;
export const OBJECT_TYPE_SHARE_USERS = 'share_users' as const;
export const OBJECT_TYPE_METADATA_CATEGORIES = 'metadata_categories' as const;
export const OBJECT_TYPE_METADATA_VIEWS = 'metadata_views' as const;
export const OBJECT_TYPE_SEARCH_VIEWS = 'search_views' as const;
export const OBJECT_TYPE_METADATA_FIELDS = 'metadata_fields' as const;
export const OBJECT_TYPE_ACL_TEMPLATES = 'acl_templates' as const;
export const OBJECT_TYPE_IDENTITY_PROVIDERS = 'identity_providers' as const;
export const OBJECT_TYPE_IP_ADDRESSES = 'ip_addresses' as const;
export const OBJECT_TYPE_LOG_STREAM_RECIPIENTS =
  'log_stream_recipients' as const;
export const OBJECT_TYPE_SUBCLIPS = 'subclips' as const;
export const OBJECT_TYPE_PERSONS = 'persons' as const;
export const OBJECT_TYPE_AUTOMATIONS = 'automations' as const;
export const OBJECT_TYPE_PLAYLISTS = 'playlists' as const;
export const OBJECT_TYPE_PORTALS = 'portals' as const;
